import { useKeycloak } from '@react-keycloak/web';
import { DialogName } from 'app/enums';
import { modalsReducers } from 'app/store/modal/slice';
import React, { FC, Children, cloneElement, ReactElement, useCallback } from 'react';
import { useDispatch } from 'react-redux';

export const ActionGuard: FC<{ disabled?: boolean }> = ({ disabled = false, children }) => {
  const { keycloak } = useKeycloak();
  const dispatch = useDispatch();

  const overriddenClickHandler = useCallback(() => {
    dispatch(modalsReducers.openModal({ name: DialogName.ActionGuard }));
  }, [dispatch]);

  if (keycloak?.authenticated || disabled) {
    return <>{children}</>;
  }

  return (
    <>
      {Children.map(children as ReactElement, (child: ReactElement) => {
        return cloneElement(child, { onClick: overriddenClickHandler });
      })}
    </>
  );
};
